import { Loader2 } from "lucide-react";

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  subMessage?: string;
}

export function LoadingOverlay({
  isVisible,
  message = "Processing...",
  subMessage,
}: LoadingOverlayProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-brand-text/50 backdrop-blur-sm">
      <div className="bg-brand-bg rounded-card p-8 shadow-deep max-w-sm w-full mx-4">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
          <div className="text-center">
            <h3 className="text-lg font-semibold text-brand-text">{message}</h3>
            {subMessage && (
              <p className="text-sm text-brand-muted mt-1">{subMessage}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
